module.exports = __webpack_public_path__ + "static/media/activerse_logo_horizontal.bf207000.svg";